/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import { OperationParameter, OperationURLParameter, OperationQueryParameter } from '@azure/core-client';
import {
    UserProgress as UserProgressMapper,
    Project as ProjectMapper,
    CvsValidationResponse as CvsValidationResponseMapper,
    Curriculum as CurriculumMapper,
    StandardGroup as StandardGroupMapper,
    Standard as StandardMapper,
    LearningPath as LearningPathMapper,
    Course as CourseMapper,
    Unit as UnitMapper,
    UserContentReport as UserContentReportMapper,
    ProjectTemplate as ProjectTemplateMapper,
} from '../models/mappers';

export const accept: OperationParameter = {
    parameterPath: 'accept',
    mapper: {
        defaultValue: 'application/json',
        isConstant: true,
        serializedName: 'Accept',
        type: {
            name: 'String',
        },
    },
};

export const $host: OperationURLParameter = {
    parameterPath: '$host',
    mapper: {
        serializedName: '$host',
        required: true,
        type: {
            name: 'String',
        },
    },
    skipEncoding: true,
};

export const userId: OperationURLParameter = {
    parameterPath: 'userId',
    mapper: {
        constraints: {
            Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
            MaxLength: 50,
        },
        serializedName: 'userId',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const contentType: OperationParameter = {
    parameterPath: ['options', 'contentType'],
    mapper: {
        defaultValue: 'application/json',
        isConstant: true,
        serializedName: 'Content-Type',
        type: {
            name: 'String',
        },
    },
};

export const body: OperationParameter = {
    parameterPath: 'body',
    mapper: {
        serializedName: 'body',
        required: true,
        type: {
            name: 'Sequence',
            element: {
                type: {
                    name: 'Composite',
                    className: 'DeleteCommand',
                },
            },
        },
    },
};

export const accept1: OperationParameter = {
    parameterPath: 'accept',
    mapper: {
        defaultValue: 'application/zip',
        isConstant: true,
        serializedName: 'Accept',
        type: {
            name: 'String',
        },
    },
};

export const contentType1: OperationParameter = {
    parameterPath: ['options', 'contentType'],
    mapper: {
        defaultValue: 'application/zip',
        isConstant: true,
        serializedName: 'Content-Type',
        type: {
            name: 'String',
        },
    },
};

export const data: OperationParameter = {
    parameterPath: ['options', 'data'],
    mapper: {
        serializedName: 'data',
        type: {
            name: 'Stream',
        },
    },
};

export const courseId: OperationURLParameter = {
    parameterPath: 'courseId',
    mapper: {
        constraints: {
            Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
            MaxLength: 50,
        },
        serializedName: 'courseId',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const body1: OperationParameter = {
    parameterPath: ['options', 'body'],
    mapper: UserProgressMapper,
};

export const projectId: OperationURLParameter = {
    parameterPath: 'projectId',
    mapper: {
        constraints: {
            Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
            MaxLength: 50,
        },
        serializedName: 'projectId',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const body2: OperationParameter = {
    parameterPath: ['options', 'body'],
    mapper: ProjectMapper,
};

export const body3: OperationParameter = {
    parameterPath: ['options', 'body'],
    mapper: CvsValidationResponseMapper,
};

export const cvsResponseKey: OperationQueryParameter = {
    parameterPath: ['options', 'cvsResponseKey'],
    mapper: {
        constraints: {
            Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
            MaxLength: 50,
        },
        serializedName: 'cvsResponseKey',
        type: {
            name: 'String',
        },
    },
};

export const accept2: OperationParameter = {
    parameterPath: 'accept',
    mapper: {
        defaultValue: '*',
        isConstant: true,
        serializedName: 'Accept',
        type: {
            name: 'String',
        },
    },
};

export const projectFilePath: OperationQueryParameter = {
    parameterPath: 'projectFilePath',
    mapper: {
        constraints: {
            Pattern: new RegExp('^(\\/(([\\w~+-]|\\.[\\w~+-])([\\w~+ -]|\\.[\\w~+ -])*)){0,5}\\/?$'),
            MaxLength: 500,
        },
        serializedName: 'projectFilePath',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const operationId: OperationURLParameter = {
    parameterPath: 'operationId',
    mapper: {
        constraints: {
            Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
            MaxLength: 50,
        },
        serializedName: 'operationId',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const curriculumId: OperationURLParameter = {
    parameterPath: 'curriculumId',
    mapper: {
        constraints: {
            Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
            MaxLength: 50,
        },
        serializedName: 'curriculumId',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const body4: OperationParameter = {
    parameterPath: ['options', 'body'],
    mapper: CurriculumMapper,
};

export const groupId: OperationURLParameter = {
    parameterPath: 'groupId',
    mapper: {
        constraints: {
            Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
            MaxLength: 50,
        },
        serializedName: 'groupId',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const body5: OperationParameter = {
    parameterPath: ['options', 'body'],
    mapper: StandardGroupMapper,
};

export const standardId: OperationURLParameter = {
    parameterPath: 'standardId',
    mapper: {
        constraints: {
            Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
            MaxLength: 50,
        },
        serializedName: 'standardId',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const body6: OperationParameter = {
    parameterPath: ['options', 'body'],
    mapper: StandardMapper,
};

export const pathId: OperationURLParameter = {
    parameterPath: 'pathId',
    mapper: {
        constraints: {
            Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
            MaxLength: 50,
        },
        serializedName: 'pathId',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const body7: OperationParameter = {
    parameterPath: ['options', 'body'],
    mapper: LearningPathMapper,
};

export const body8: OperationParameter = {
    parameterPath: ['options', 'body'],
    mapper: CourseMapper,
};

export const unitId: OperationURLParameter = {
    parameterPath: 'unitId',
    mapper: {
        constraints: {
            Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
            MaxLength: 50,
        },
        serializedName: 'unitId',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const body9: OperationParameter = {
    parameterPath: ['options', 'body'],
    mapper: UnitMapper,
};

export const packageId: OperationURLParameter = {
    parameterPath: 'packageId',
    mapper: {
        constraints: {
            Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
            MaxLength: 50,
        },
        serializedName: 'packageId',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const containerName: OperationURLParameter = {
    parameterPath: 'containerName',
    mapper: {
        constraints: {
            Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
            MaxLength: 50,
        },
        serializedName: 'containerName',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const blobName: OperationURLParameter = {
    parameterPath: 'blobName',
    mapper: {
        constraints: {
            Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
            MaxLength: 50,
        },
        serializedName: 'blobName',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const body10: OperationParameter = {
    parameterPath: ['options', 'body'],
    mapper: {
        serializedName: 'body',
        type: {
            name: 'Dictionary',
            value: { type: { name: 'String' } },
        },
    },
};

export const body11: OperationParameter = {
    parameterPath: ['options', 'body'],
    mapper: UserContentReportMapper,
};

export const appName: OperationURLParameter = {
    parameterPath: 'appName',
    mapper: {
        constraints: {
            Pattern: new RegExp(
                '^[a-zA-Z-]{1,32}[0-9]{0,4}(\\.[vV][sS][cC][oO][dD][eE][eE][dD][uU]\\.[aA][pP][pP]|\\.[pP][pP][eE]-[aA][pP][pP]\\.[vV][sS][cC][oO][dD][eE][eE][dD][uU]\\.[cC][oO][mM])?$'
            ),
            MaxLength: 100,
        },
        serializedName: 'appName',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const appFilePath: OperationURLParameter = {
    parameterPath: 'appFilePath',
    mapper: {
        constraints: {
            Pattern: new RegExp('^(\\/(([\\w~+-]|\\.[\\w~+-])([\\w~+ -]|\\.[\\w~+ -])*)){0,5}\\/?$'),
            MaxLength: 500,
        },
        serializedName: 'appFilePath',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const templateId: OperationURLParameter = {
    parameterPath: 'templateId',
    mapper: {
        constraints: {
            Pattern: new RegExp('^[a-z\\d.](?:[a-z\\d.-]{0,48}[a-z\\d.])?$'),
            MaxLength: 50,
        },
        serializedName: 'templateId',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const body12: OperationParameter = {
    parameterPath: ['options', 'body'],
    mapper: ProjectTemplateMapper,
};

export const accept3: OperationParameter = {
    parameterPath: 'accept',
    mapper: {
        defaultValue: 'text/plain',
        isConstant: true,
        serializedName: 'Accept',
        type: {
            name: 'String',
        },
    },
};

export const authProvider: OperationQueryParameter = {
    parameterPath: ['startSessionOptions', 'authProvider'],
    mapper: {
        serializedName: 'authProvider',
        required: true,
        type: {
            name: 'Enum',
            allowedValues: ['microsoft', 'google', 'clever'],
        },
    },
};

export const redirectUrl: OperationQueryParameter = {
    parameterPath: ['startSessionOptions', 'redirectUrl'],
    mapper: {
        constraints: {
            Pattern: new RegExp(
                '^(?:(https?:\\/\\/(?:www\\.)?[-\\w@:%.\\+~#=]{1,256}\\.[a-zA-Z\\d()]{1,6}\\b[-\\w()@:%+.~#?&\\/=]{0,740}))$'
            ),
            MaxLength: 1000,
        },
        serializedName: 'redirectUrl',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const longTerm: OperationQueryParameter = {
    parameterPath: ['startSessionOptions', 'longTerm'],
    mapper: {
        serializedName: 'longTerm',
        required: true,
        type: {
            name: 'Boolean',
        },
    },
};

export const state: OperationQueryParameter = {
    parameterPath: ['exchangeSessionOptions', 'state'],
    mapper: {
        constraints: {
            Pattern: new RegExp('^(?:[\\w-]{0,1000}\\.){2}[\\w-]{0,1000}$'),
            MaxLength: 3500,
        },
        serializedName: 'state',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const accessCode: OperationQueryParameter = {
    parameterPath: ['exchangeSessionOptions', 'accessCode'],
    mapper: {
        constraints: {
            MaxLength: 512,
        },
        serializedName: 'accessCode',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const authProvider1: OperationQueryParameter = {
    parameterPath: ['newSessionOptions', 'authProvider'],
    mapper: {
        serializedName: 'authProvider',
        required: true,
        type: {
            name: 'Enum',
            allowedValues: ['microsoft', 'google', 'clever'],
        },
    },
};

export const longTerm1: OperationQueryParameter = {
    parameterPath: ['newSessionOptions', 'longTerm'],
    mapper: {
        serializedName: 'longTerm',
        required: true,
        type: {
            name: 'Boolean',
        },
    },
};

export const accessCode1: OperationQueryParameter = {
    parameterPath: ['newSessionOptions', 'accessCode'],
    mapper: {
        constraints: {
            MaxLength: 512,
        },
        serializedName: 'accessCode',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const redirectUrl1: OperationQueryParameter = {
    parameterPath: ['newSessionOptions', 'redirectUrl'],
    mapper: {
        constraints: {
            Pattern: new RegExp(
                '^(?:(https?:\\/\\/(?:www\\.)?[-\\w@:%.\\+~#=]{1,256}\\.[a-zA-Z\\d()]{1,6}\\b[-\\w()@:%+.~#?&\\/=]{0,740}))$'
            ),
            MaxLength: 1000,
        },
        serializedName: 'redirectUrl',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const codeChallenge: OperationQueryParameter = {
    parameterPath: ['newOtacOptions', 'codeChallenge'],
    mapper: {
        constraints: {
            Pattern: new RegExp('^[A-Za-z0-9-_]{43}$'),
            MaxLength: 43,
        },
        serializedName: 'codeChallenge',
        type: {
            name: 'String',
        },
    },
};

export const longTerm2: OperationQueryParameter = {
    parameterPath: ['newOtacOptions', 'longTerm'],
    mapper: {
        serializedName: 'longTerm',
        required: true,
        type: {
            name: 'Boolean',
        },
    },
};

export const otac: OperationQueryParameter = {
    parameterPath: ['exchangeOtacOptions', 'otac'],
    mapper: {
        constraints: {
            Pattern: new RegExp('^[a-zA-Z0-9]{0,10}$'),
            MaxLength: 10,
        },
        serializedName: 'otac',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const codeVerifier: OperationQueryParameter = {
    parameterPath: ['exchangeOtacOptions', 'codeVerifier'],
    mapper: {
        constraints: {
            Pattern: new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$'),
            MaxLength: 36,
        },
        serializedName: 'codeVerifier',
        type: {
            name: 'String',
        },
    },
};

export const linkId: OperationURLParameter = {
    parameterPath: 'linkId',
    mapper: {
        constraints: {
            Pattern: new RegExp('^[a-zA-Z0-9]{20}$'),
            MaxLength: 20,
            MinLength: 20,
        },
        serializedName: 'linkId',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const redirectUrl2: OperationQueryParameter = {
    parameterPath: 'redirectUrl',
    mapper: {
        constraints: {
            Pattern: new RegExp(
                '^(?:(https?:\\/\\/(?:www\\.)?[-\\w@:%.\\+~#=]{1,256}\\.[a-zA-Z\\d()]{1,6}\\b[-\\w()@:%+.~#?&\\/=]{0,740}))$'
            ),
            MaxLength: 1000,
        },
        serializedName: 'redirectUrl',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const accessCode2: OperationQueryParameter = {
    parameterPath: ['githubInstallExchangeOptions', 'accessCode'],
    mapper: {
        constraints: {
            MaxLength: 512,
        },
        serializedName: 'accessCode',
        required: true,
        type: {
            name: 'String',
        },
    },
};

export const state1: OperationQueryParameter = {
    parameterPath: ['githubInstallExchangeOptions', 'state'],
    mapper: {
        constraints: {
            Pattern: new RegExp('^(?:[\\w-]{0,1000}\\.){2}[\\w-]{0,1000}$'),
            MaxLength: 3500,
        },
        serializedName: 'state',
        required: true,
        type: {
            name: 'String',
        },
    },
};
